// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__CuqmN","description":"MealItem_description__2CK48","price":"MealItem_price__3SyTl"};